/**
 * 转场特效 - move（普通的上下左右移入移出）
 * 2018-10-8
 */
// (function(global) {
//     if (!global.AnimEditor) return;
    
//     // 类构造函数
//     function con(scene, option) {
//         this.code = option.code || 'UpIn';
//     }

//     // 方法
//     var methods = {
//         init: function() {
//             this.duration = 0.5; // 动效持续时间
//             this.startAt = 0.25; // 开始时间（场景结束前n秒）

//             return this.supr(this.startAt).then(function () {
//             });
//         },

//         show: function (frame) {
//             // 播放
//             if (!this.isInit) return;
//             this.supr(frame);

//             var scene = this.scene,
//                 editor = scene.editor,
//                 sele = scene.element.player; // plyaer层的当前scene

//             var h = editor.clientHeight,
//                 w = editor.clientWidth;

//             // 播放层显示，对应scene显示
//             editor.player.ele.show();
//             sele.show();

//             // 前250ms
//             if (frame <= this.entrance.end) {
//                 this.showFirst(frame)
//             }

//             // 后250ms
//             if (this.nexts && frame >= this.exit.start) {
//                 // 隐藏上一个场景页的遮罩
//                 this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();

//                 var nexts_ele = this.nexts.element.player; // player层中的下一个场景
//                 var offframe = frame - this.exit.start; // 当前帧减去动画开始时的帧(动画的帧)

//                 nexts_ele.show();

//                 switch(this.code) {
//                     case 'UpIn':
//                         // 本场景上移出场，下一个场景页上移入场
//                         sele.css({ top: this._easingAnim(offframe, 0, -h, this.totalFrame), left: 0 });
//                         nexts_ele.css({ top: this._easingAnim(offframe, h, -h, this.totalFrame), left: 0});
//                         break;
//                     case 'DownIn':
//                         // 本场景下移出场，下一个场景页下移入场
//                         sele.css({ top: this._easingAnim(offframe, 0, h, this.totalFrame), left: 0 });
//                         nexts_ele.css({ top: this._easingAnim(offframe, -h, h, this.totalFrame), left: 0});
//                         break;
//                     case 'LeftIn':
//                         // 本场景右移出场，下一个场景页右移入场
//                         sele.css({ left: this._easingAnim(offframe, 0, -w, this.totalFrame), top: 0 });
//                         nexts_ele.css({ left: this._easingAnim(offframe, w, -w, this.totalFrame), top: 0 });
//                         break;
//                     case 'RightIn':
//                         // 本场景左移出场，下一个场景页左移入场
//                         sele.css({ left : this._easingAnim(offframe, 0, w, this.totalFrame), top: 0 });
//                         nexts_ele.css({left : this._easingAnim(offframe, -w, w, this.totalFrame), top: 0 });
//                         break;
//                     case 'None':
//                     default:
//                         sele.show();
//                         nexts_ele.hide();
//                 }
//             }

//             // 动画区间外，隐藏其它元素，恢复位置(本场景页)
//             if (frame > this.entrance.end && frame < this.exit.start) {
//                 this.showMiddle()
//             }
//         },

//         // 为下一个场景提供方法以完成动画衔接(注释对应上边)
//         showNext: function(frame) {
//             var scene = this.scene,
//                 editor = scene.editor,
//                 sele = scene.element.player;

//             var h = editor.clientHeight,
//                 w = editor.clientWidth;

//             var next_ele = this.nexts.element.player;

//             var _currentFrame = this.startAt * this.frameRate + frame;

//             switch(scene.effect.code) {
//                 case 'UpIn':
//                     sele.css({ top: this._easingAnim(_currentFrame, 0, -h, this.totalFrame), left: 0 });
//                     next_ele.css({ top: this._easingAnim(_currentFrame, h, -h, this.totalFrame), left: 0 });
//                     break;
//                 case 'DownIn':
//                     sele.css({ top: this._easingAnim(_currentFrame, 0, h, this.totalFrame), left: 0 });
//                     next_ele.css({ top: this._easingAnim(_currentFrame, -h, h, this.totalFrame), left: 0});
//                     break;
//                 case 'LeftIn':
//                     sele.css({ left: this._easingAnim(_currentFrame, 0, -w, this.totalFrame), top: 0 });
//                     next_ele.css({ left: this._easingAnim(_currentFrame, w, -w, this.totalFrame), top: 0});
//                     break;
//                 case 'RightIn':
//                     sele.css({ left: this._easingAnim(_currentFrame, 0, w, this.totalFrame), top: 0 });
//                     next_ele.css({ left: this._easingAnim(_currentFrame, -w, w, this.totalFrame), top: 0 });
//                     break;
//             }
//         },

//         _easingAnim: function(t, b, c, d) {
//             // 使用的easeOutQuad缓动函数
//             return  -c *(t/=d)*(t-2) + b;
//         }
//     }

//     // 静态方法
//     var statics = {

//     }

//     // 挂载到SceneEffects
//     global.AnimEditor.extendScenesEffect('move', con, methods, statics);
//     return;
// })(window);

(function (root, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        // CommonJS
        module.exports = factory(this);
    } else {
        //  全局变量
        factory(root);
    }
})(this, function(root) {

    // 类构造函数
    function con(scene, option) {
        this.code = option.code || 'UpIn';
    }

    // 方法
    var methods = {
        init: function() {
            this.duration = 0.5; // 动效持续时间
            this.startAt = 0.25; // 开始时间（场景结束前n秒）

            return this.supr(this.startAt).then(function () {
            });
        },

        show: function (frame) {
            // 播放
            if (!this.isInit) return;
            this.supr(frame);

            var scene = this.scene,
                editor = scene.editor,
                sele = scene.element.player; // plyaer层的当前scene

            var h = editor.clientHeight,
                w = editor.clientWidth;

            // 播放层显示，对应scene显示
            editor.player.ele.show();
            sele.show();

            // 前250ms
            if (frame <= this.entrance.end) {
                this.showFirst(frame)
            }

            // 后250ms
            if (this.nexts && frame >= this.exit.start) {
                // 隐藏上一个场景页的遮罩
                this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();

                var nexts_ele = this.nexts.element.player; // player层中的下一个场景
                var offframe = frame - this.exit.start; // 当前帧减去动画开始时的帧(动画的帧)

                nexts_ele.show();

                switch(this.code) {
                    case 'UpIn':
                        // 本场景上移出场，下一个场景页上移入场
                        sele.css({ top: this._easingAnim(offframe, 0, -h, this.totalFrame), left: 0 });
                        nexts_ele.css({ top: this._easingAnim(offframe, h, -h, this.totalFrame), left: 0});
                        break;
                    case 'DownIn':
                        // 本场景下移出场，下一个场景页下移入场
                        sele.css({ top: this._easingAnim(offframe, 0, h, this.totalFrame), left: 0 });
                        nexts_ele.css({ top: this._easingAnim(offframe, -h, h, this.totalFrame), left: 0});
                        break;
                    case 'LeftIn':
                        // 本场景右移出场，下一个场景页右移入场
                        sele.css({ left: this._easingAnim(offframe, 0, -w, this.totalFrame), top: 0 });
                        nexts_ele.css({ left: this._easingAnim(offframe, w, -w, this.totalFrame), top: 0 });
                        break;
                    case 'RightIn':
                        // 本场景左移出场，下一个场景页左移入场
                        sele.css({ left : this._easingAnim(offframe, 0, w, this.totalFrame), top: 0 });
                        nexts_ele.css({left : this._easingAnim(offframe, -w, w, this.totalFrame), top: 0 });
                        break;
                    case 'None':
                    default:
                        sele.show();
                        nexts_ele.hide();
                }
            }

            // 动画区间外，隐藏其它元素，恢复位置(本场景页)
            if (frame > this.entrance.end && frame < this.exit.start) {
                this.showMiddle()
            }
        },

        // 为下一个场景提供方法以完成动画衔接(注释对应上边)
        showNext: function(frame) {
            var scene = this.scene,
                editor = scene.editor,
                sele = scene.element.player;

            var h = editor.clientHeight,
                w = editor.clientWidth;

            var next_ele = this.nexts.element.player;

            var _currentFrame = this.startAt * this.frameRate + frame;

            switch(scene.effect.code) {
                case 'UpIn':
                    sele.css({ top: this._easingAnim(_currentFrame, 0, -h, this.totalFrame), left: 0 });
                    next_ele.css({ top: this._easingAnim(_currentFrame, h, -h, this.totalFrame), left: 0 });
                    break;
                case 'DownIn':
                    sele.css({ top: this._easingAnim(_currentFrame, 0, h, this.totalFrame), left: 0 });
                    next_ele.css({ top: this._easingAnim(_currentFrame, -h, h, this.totalFrame), left: 0});
                    break;
                case 'LeftIn':
                    sele.css({ left: this._easingAnim(_currentFrame, 0, -w, this.totalFrame), top: 0 });
                    next_ele.css({ left: this._easingAnim(_currentFrame, w, -w, this.totalFrame), top: 0});
                    break;
                case 'RightIn':
                    sele.css({ left: this._easingAnim(_currentFrame, 0, w, this.totalFrame), top: 0 });
                    next_ele.css({ left: this._easingAnim(_currentFrame, -w, w, this.totalFrame), top: 0 });
                    break;
            }
        },

        _easingAnim: function(t, b, c, d) {
            // 使用的easeOutQuad缓动函数
            return  -c *(t/=d)*(t-2) + b;
        }
    }

    // 静态方法
    var statics = {

    }

    if (root.AnimEditor) {
        // 挂载到SceneEffects
        root.AnimEditor.extendScenesEffect('move', con, methods, statics);
        return;
    }

    return function(AnimEditor) {
        AnimEditor.extendScenesEffect('move', con, methods, statics);
    }
});



//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-move.js
// module id = x4iz
// module chunks = 16